<div class="container-tablet h-100">
  <div class="mb-3 d-flex">
    <div
      class="col-2 d-flex align-items-center justify-content-center"
      routerLink="home-tablet"
    >
      <i class="bi bi-arrow-left-circle-fill" style="font-size: 32px"></i>
    </div>

    <h1 class="fw-bold col-8 text-center" style="font-size: 44px">
      RUTINAS DEL DÍA
    </h1>
  </div>

  <app-autoassigned-routine
    *ngFor="let routine of autoassignedRoutines"
    [routerLink]="'/routine-model-tablet' + '/' + routine.routineModelId"
    (click)="selectTabletRoutine(routine)"
    [autoassignedRoutine]="routine"
  ></app-autoassigned-routine>
</div>
<div class="bottom-part p-4">
  <button class="btn-custom w-100" (click)="openFormModal()">
    CREAR MI RUTINA DEL DÍA +
  </button>
</div>

<app-tablet-routine-form></app-tablet-routine-form>
